module.exports = __webpack_public_path__ + "assets/img/6_525.023a9638.jpg";